import styled from 'styled-components';

export const TableSelect = styled.select`
  width: 100%;
  height: 1.65rem;
`;
